import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import ProgressBar from "@services/ui-components/src/ProgressBar/ProgressBar";
import { InfoBanner } from "@services/ui-components";
import { Container } from "react-bootstrap";
import { getBusinessTypeOptions } from "../BusinessTypeSelector/BusinessTypeOptions";
import { BUSINESS_TYPE, BusinessType } from "../BusinessTypeSelector/businessType";
import CreateServiceBusinessCompanyForm from "./tabs/CreateServiceBusinessCompanyForm/CreateServiceBusinessCompanyForm";
import CreateFoodBusinessCompanyForm from "./tabs/CreateFoodBusinessCompanyForm/CreateFoodBusinessCompanyForm";
import CreateOtherBusinessCompanyForm from "./tabs/CreateOtherBusinessCompanyForm/CreateOtherBusinessCompanyForm";

//  TODO требуется рефакторинг: нужно вынести из форм выполнение запросов query в родительский
//   компонент CreateCompany, чтоб их не дублировать и не вызывать повторно при переключении
//   между типами бизнеса в каждой форме, а вызывать при рендере всей
//   страницы, закэшировать и пропсами уже прокидывать готовые данные по формам (желательно
//   сразу делать и в создании филиала CreateBranch, там аналогичная ситация)

interface IStep {
    key: string;
    label: string;
}

const steps = (t: any): IStep[] => [
    { key: "registration", label: t("Registration") },
    { key: "create-company", label: t("Create company") },
    { key: "create-owner", label: t("Create owner") },
];

const CreateCompany = () => {
    const { t } = useTranslation();
    const stepsArray = steps(t);
    const [selectedBusinessType, setSelectedBusinessType] = useState<BusinessType>(BUSINESS_TYPE.SERVICE);
    const businessTypeOptions = useMemo(() => getBusinessTypeOptions(t), [t]);

    const activeBusinessTypeForm = useMemo(() => {
        switch (selectedBusinessType) {
            case BUSINESS_TYPE.SERVICE:
                return (
                    <CreateServiceBusinessCompanyForm
                        selectedBusinessType={selectedBusinessType}
                        businessTypeOptions={businessTypeOptions}
                        onBusinessTypeChange={setSelectedBusinessType}
                    />
                );

            case BUSINESS_TYPE.FOOD:
                return (
                    <CreateFoodBusinessCompanyForm
                        selectedBusinessType={selectedBusinessType}
                        businessTypeOptions={businessTypeOptions}
                        onBusinessTypeChange={setSelectedBusinessType}
                    />
                );

            case BUSINESS_TYPE.OTHER:
                return (
                    <CreateOtherBusinessCompanyForm
                        selectedBusinessType={selectedBusinessType}
                        businessTypeOptions={businessTypeOptions}
                        onBusinessTypeChange={setSelectedBusinessType}
                    />
                );

            default:
                return (
                    <CreateServiceBusinessCompanyForm
                        selectedBusinessType={selectedBusinessType}
                        businessTypeOptions={businessTypeOptions}
                        onBusinessTypeChange={setSelectedBusinessType}
                    />
                );
        }
    }, [businessTypeOptions, selectedBusinessType]);

    return (
        <Container fluid className="px-0 px-lg-6">
            <ProgressBar currentStep={1} steps={stepsArray} />
            <InfoBanner>
                <p className="mb-0">
                    {t(
                        "Please fill in the information about your company. Required fields are marked with an asterisk - *."
                    )}
                </p>
            </InfoBanner>
            <h2 className="mb-4">{t("company")}</h2>
            <Row>
                <Col lg={12}>{activeBusinessTypeForm}</Col>
            </Row>
        </Container>
    );
};

export default CreateCompany;
